import { motion } from 'framer-motion';

const reasons = [
  {
    icon: 'ri-rocket-2-line',
    title: 'Proceso rápido y guiado',
    desc: 'Te acompañamos paso a paso, explicando cada etapa para que no pierdas tiempo ni cometas errores.',
  },
  {
    icon: 'ri-user-voice-line',
    title: 'Atención directa',
    desc: 'Sin intermediarios. Hablas directamente con quién lleva tu caso y siempre sabes el estado de tu trámite.',
  },
  {
    icon: 'ri-briefcase-4-line',
    title: 'Experiencia en trámites legales',
    desc: 'Contamos con experiencia comprobada en la gestión de posesiones efectivas en Chile, tanto intestadas como testamentarias.',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Acompañamiento completo',
    desc: 'Desde la primera consulta hasta la inscripción final de los bienes, estamos contigo en cada paso.',
  },
];

const PosesionWhyUs = () => {
  return (
    <section className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="inline-block bg-primary-yellow text-black text-xs font-black uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">
              Por qué elegirnos
            </span>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-6">
              Tu herencia merece
              <br />
              <span className="text-primary-yellow">un equipo dedicado</span>
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed mb-8">
              La posesión efectiva es un trámite que puede parecer complejo. Nosotros lo simplificamos para que tú solo te preocupes de lo que realmente importa.
            </p>

            {/* Authority statement */}
            <div className="bg-white/5 border border-primary-yellow/30 rounded-2xl p-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-yellow rounded-xl flex-shrink-0">
                  <i className="ri-scales-3-line text-black text-lg"></i>
                </div>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Trabajamos con abogados y procesos estructurados para asegurar que tu trámite se realice <strong className="text-white">correctamente desde el inicio</strong>, sin errores ni correcciones posteriores.
                </p>
              </div>
            </div>

            {/* Visual metric */}
            <div className="grid grid-cols-2 gap-4">
              {[
                { num: '+300', label: 'Trámites completados' },
                { num: '100%', label: 'Seguimiento incluido' },
                { num: '2', label: 'Vías de tramitación' },
                { num: '0', label: 'Burocracia para ti' },
              ].map((m, idx) => (
                <div key={idx} className="bg-white/5 border border-white/10 rounded-xl p-5">
                  <p className="text-primary-yellow text-3xl font-black">{m.num}</p>
                  <p className="text-gray-400 text-xs mt-1">{m.label}</p>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Right — reasons list */}
          <div className="space-y-5">
            {reasons.map((r, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1, duration: 0.5 }}
                className="flex items-start gap-5 bg-white/5 border border-white/8 rounded-2xl p-6"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary-yellow rounded-xl flex-shrink-0">
                  <i className={`${r.icon} text-black text-xl`}></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-base mb-1.5">{r.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{r.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PosesionWhyUs;
